import React, { Suspense } from "react";
import { Providers } from "./providers";
import { AppRoutes } from "./routes";
import { IS_ONPREM } from "@shared/config/edition";
import "@/styles/themes.css";
import "@/styles/base.scss";

// On-prem only: the licence gate (activation / lock screen, expiry warning).
// Decided at build time, so the SaaS bundle does not contain it.
const LicenceGate = IS_ONPREM ? React.lazy(() => import("@features/licence/LicenceGate")) : null;

const App: React.FC = () => (
  <Providers>
    {LicenceGate ? (
      <Suspense fallback={null}>
        <LicenceGate>
          <AppRoutes />
        </LicenceGate>
      </Suspense>
    ) : (
      <AppRoutes />
    )}
  </Providers>
);

export default App;

